module.exports = __webpack_public_path__ + "static/img/class_4.42ed705f.jpg";